import {classInstance} from '@/shared/helpers/helpers';

export class CatalogFilterSection {
	private readonly element: HTMLElement | null;
	private readonly nameSelector: string = '.catalog-filter-section__name';
	private readonly nameResetSelector: string = '.catalog-filter-section__name-reset';
	private readonly openerSelector: string = '.catalog-filter-section__opener';
	private readonly moreSelector: string = '.catalog-filter-section__more';
	private readonly itemSelector: string = '.catalog-filter-section__item';
	private readonly activeClass: string = 'catalog-filter-section--active';
	private readonly activeItemClass: string = 'catalog-filter-section__item--active';
	private readonly activeChecksClass: string = 'catalog-filter-section__checks--active';
	private readonly activeCheckClass: string = 'catalog-filter-section__check--active';
	private checksElement: HTMLElement | null;
	private switcherElement: HTMLLabelElement | null;
	private checkElements: HTMLElement[] = [];
	private searchElement: HTMLInputElement | null;

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	private handleClick = ({ target }: MouseEvent): void => {
		const clicked = target as HTMLElement;

		const name = clicked.closest(this.nameSelector);
		const nameReset = name?.querySelector(this.nameResetSelector);
		const isLink = clicked.closest('a');
		const opener = clicked.closest(this.openerSelector);
		const item = clicked.closest(this.itemSelector);
		const more = clicked.closest(this.moreSelector);

		if (name && !isLink && !nameReset && !this.switcherElement) this.element.classList.toggle(this.activeClass);

		if (opener && item) item.classList.toggle(this.activeItemClass);

		if (more && this.checksElement) this.checksElement.classList.toggle(this.activeChecksClass);
	};

	private handleSearchInput = ({ target }: InputEvent): void => {
		const input = target as HTMLInputElement;
		const { value } = input;

		this.checkElements.forEach((element) => {
			const nameElement: HTMLElement = element.querySelector('.catalog-filter-section__check-name');
			const elementValue = nameElement.innerText;
			const hasValue = elementValue.toLowerCase().indexOf(value.toLowerCase()) > -1 && value.length;
			if (hasValue) element.classList.add(this.activeCheckClass);
			else element.classList.remove(this.activeCheckClass);
		});
	};

	public init = (): void => {
		if (!this.element) return;
		classInstance.set(this.element, { catalogFilterSection: this });
		this.element.addEventListener('click', this.handleClick);
		this.checksElement = this.element.querySelector('.catalog-filter-section__checks');
		this.switcherElement = this.element.querySelector('.catalog-filter-section__switcher');
		if (this.checksElement) this.checkElements = Array.from(this.checksElement?.querySelectorAll('.catalog-filter-section__check'));
		this.searchElement = this.element.querySelector('.catalog-filter-section__search .form-input');
		if (this.checkElements && this.searchElement) this.searchElement.addEventListener('input', this.handleSearchInput);
	};

	public destroy = (): void => {
		if (!this.element) return;
		classInstance.del(this.element, 'catalogFilterSection');
		this.element.removeEventListener('click', this.handleClick);
		this.checksElement = null;
		this.switcherElement = null;
		this.checkElements = null;
		this.searchElement = null;
	};
}
